/**
 * Space scrollable content reserves for the floating bottom navigation.
 *
 * The 142-point clearance allows for the 60-point navigation pill, the larger
 * Android system-navigation offset (up to 64 points), and 18 points of visual space.
 */
export const BOTTOM_NAVIGATION_CLEARANCE = 142;
